
import React from "react";
import { SwapRequest } from "@/services/myReagents";
import PendingRequestsSection from "./PendingRequestsSection";
import PastRequestsSection from "./PastRequestsSection";
import EmptyRequestsState from "./EmptyRequestsState";

interface SwapRequestsTabContentProps {
  requests: SwapRequest[];
  isSentByUser: boolean;
  onApprove?: (request: SwapRequest) => void;
  onReject?: (request: SwapRequest) => void;
  onEdit?: (request: SwapRequest) => void;
  onDelete?: (request: SwapRequest) => void;
}

const SwapRequestsTabContent: React.FC<SwapRequestsTabContentProps> = ({
  requests,
  isSentByUser,
  onApprove,
  onReject,
  onEdit,
  onDelete
}) => {
  if (requests.length === 0) {
    return (
      <EmptyRequestsState 
        message={`You haven't ${isSentByUser ? 'sent' : 'received'} any swap requests yet.`}
      />
    );
  }

  // Get pending and other requests
  const pendingRequests = requests.filter(req => req.status === "pending");
  const otherRequests = requests.filter(req => req.status !== "pending");

  return (
    <div className="space-y-6">
      {pendingRequests.length > 0 && (
        <PendingRequestsSection
          requests={pendingRequests}
          isSentByUser={isSentByUser}
          onApprove={isSentByUser ? undefined : onApprove}
          onReject={isSentByUser ? undefined : onReject}
          onEdit={isSentByUser ? onEdit : undefined}
          onDelete={isSentByUser ? onDelete : undefined}
        />
      )}
      
      {otherRequests.length > 0 && (
        <PastRequestsSection
          requests={otherRequests}
          isSentByUser={isSentByUser}
        />
      )}
    </div>
  );
};

export default SwapRequestsTabContent;
